'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = require('./i18next');

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _i18next2.default;


//////////////////
// WEBPACK FOOTER
// ./~/i18next/dist/commonjs/index.js
// module id = 1020
// module chunks = 0